import React from 'react';
import { RotateCcw } from 'lucide-react';
import { toast } from 'sonner';
import theme from '../theme';
import { guidedTourKey, guidedTourSkipKey } from './GuidedTour';

export default function ResetTourButton({ user }) {
  if (!user?.id || !user?.role) return null;
  const onClick = () => {
    localStorage.removeItem(guidedTourKey(user.id, user.role));
    localStorage.removeItem(guidedTourSkipKey(user.id, user.role));
    toast.success('Guided tour reset — launching now…');
    setTimeout(() => window.dispatchEvent(new Event('guided-tour:start')), 200);
  };
  return (
    <button
      data-testid="reset-tour-btn"
      onClick={onClick}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '8px',
        padding: '8px 14px', background: 'transparent',
        border: `1px solid ${theme.colors.borders}`, borderRadius: theme.radius.sm,
        cursor: 'pointer', fontSize: '13px', fontWeight: 600, color: theme.colors.text.primary,
      }}>
      <RotateCcw size={14} /> Reset Tour
    </button>
  );
}
